const actionTypes = {
  DELETE_PAYROLL: "PRP_DELETE_PAYROLL",
  DELETE_PAYROLL_LINE: "PRP_DELETE_PAYROLL_LINE",
  DELETE_PAYROLL_LINES: "PRP_DELETE_PAYROLL_LINES",
  GET_CONFIG: "PRP_GET_CONFIG",
  GET_CONFIG_ALERTS: "PRP_GET_CONFIG_ALERTS",
  GET_CONFIG_HOLIDAYS: "PRP_GET_CONFIG_HOLIDAYS",
  GET_EMPLOYEE: "PRP_GET_EMPLOYEE",
  GET_LEDGER_PDF: "PRP_GET_LEDGER_PDF",
  GET_LEDGERS: "PRP_GET_LEDGERS",
  GET_LEDGERS_TOTAL: "PRP_GET_LEDGERS_TOTAL",
  GET_LINE_PDF: "PRP_GET_LINE_PDF",
  GET_LINES_AVAILABLE: "PRP_GET_LINES_AVAILABLE",
  GET_LINES_TRANSIENT: "PRP_GET_LINES_TRANSIENT",
  GET_LINES_TRANSIENT_TOTAL: "PRP_GET_LINES_TRANSIENT_TOTAL",
  GET_ME_CLIENTS: "PRP_GET_ME_CLIENTS",
  GET_ME_CONFIG: "PRP_GET_ME_CONFIG",
  GET_ME_CONFIG_ALERTS: "PRP_GET_ME_CONFIG_ALERTS",
  GET_ME_CONFIG_HOLIDAYS: "PRP_GET_ME_CONFIG_HOLIDAYS",
  GET_ME_INFO: "PRP_GET_ME_INFO",
  GET_ME_JOB: "PRP_GET_ME_JOB",
  GET_ME_JOBS: "PRP_GET_ME_JOBS",
  GET_ME_LEDGER: "PRP_GET_ME_LEDGER",
  GET_ME_LEDGERS: "PRP_GET_ME_LEDGERS",
  GET_ME_LEDGERS_TOTAL: "PRP_GET_ME_LEDGERS_TOTAL",
  GET_ME_LINE: "PRP_GET_ME_LINE",
  GET_ME_LINES: "PRP_GET_ME_LINES",
  GET_ME_LINES_TOTAL: "PRP_GET_ME_LINES_TOTAL",
  GET_PAYROLL: "PRP_GET_PAYROLL",
  GET_PAYROLL_EXPORT: "PRP_GET_PAYROLL_EXPORT",
  GET_PAYROLLS: "PRP_GET_PAYROLLS",
  PATCH_LINE_SKIP: "PRP_PATCH_LINE_SKIP",
  PATCH_PAYROLL_AUTHORISE: "PRP_PATCH_PAYROLL_AUTHORISE",
  PATCH_PAYROLL_LINE: "PRP_PATCH_PAYROLL_LINE",
  PATCH_PAYROLL_LINE_REVISE: "PRP_PATCH_PAYROLL_LINE_REVISE",
  PATCH_PAYROLL_UNLOCK: "PRP_PATCH_PAYROLL_UNLOCK",
  POST_CONVERT: "PRP_POST_CONVERT",
  POST_EXPORT_INVOICES: "PRP_POST_EXPORT_INVOICES",
  POST_IMPORT_LEDGERS: "PRP_POST_IMPORT_LEDGERS",
  POST_LEDGERS: "PRP_POST_LEDGERS",
  POST_LINES_PROCESS: "PRP_POST_LINES_PROCESS",
  POST_ME_REQUEST_CURRENCY: "PRP_POST_ME_REQUEST_CURRENCY",
  POST_ME_REQUEST_INVOICE: "PRP_POST_ME_REQUEST_INVOICE",
  POST_PAYROLL_LINES: "PRP_POST_PAYROLL_LINES",
  POST_PAYROLL_REVISE: "PRP_POST_PAYROLL_REVISE",
  POST_PAYROLLS: "PRP_POST_PAYROLLS",
  STORE: "PRP_STORE",
  STORE_CONFIG: "PRP_STORE_CONFIG",
  STORE_CONFIG_ALERTS: "PRP_STORE_CONFIG_ALERTS",
  STORE_CONFIG_HOLIDAYS: "PRP_STORE_CONFIG_HOLIDAYS",
  STORE_EMPLOYEE: "PRP_STORE_EMPLOYEE",
  STORE_LEDGERS: "PRP_STORE_LEDGERS",
  STORE_LEDGERS_TOTAL: "PRP_STORE_LEDGERS_TOTAL",
  STORE_LINES_AVAILABLE: "PRP_STORE_LINES_AVAILABLE",
  STORE_LINES_TRANSIENT: "PRP_STORE_LINES_TRANSIENT",
  STORE_LINES_TRANSIENT_TOTAL: "PRP_STORE_LINES_TRANSIENT_TOTAL",
  STORE_ME_CLIENTS: "PRP_STORE_ME_CLIENTS",
  STORE_ME_CONFIG: "PRP_STORE_ME_CONFIG",
  STORE_ME_CONFIG_ALERTS: "PRP_STORE_ME_CONFIG_ALERTS",
  STORE_ME_CONFIG_HOLIDAYS: "PRP_STORE_ME_CONFIG_HOLIDAYS",
  STORE_ME_INFO: "PRP_STORE_ME_INFO",
  STORE_ME_JOB: "PRP_STORE_ME_JOB",
  STORE_ME_JOBS: "PRP_STORE_ME_JOBS",
  STORE_ME_LEDGER: "PRP_STORE_ME_LEDGER",
  STORE_ME_LEDGERS: "PRP_STORE_ME_LEDGERS",
  STORE_ME_LEDGERS_TOTAL: "PRP_STORE_ME_LEDGERS_TOTAL",
  STORE_ME_LINE: "PRP_STORE_ME_LINE",
  STORE_ME_LINES: "PRP_STORE_ME_LINES",
  STORE_ME_LINES_TOTAL: "PRP_STORE_ME_LINES_TOTAL",
  STORE_PAYROLL: "PRP_STORE_PAYROLL",
  STORE_PAYROLL_LINE: "PRP_STORE_PAYROLL_LINE",
  STORE_PAYROLLS: "PRP_STORE_PAYROLLS",
  UPDATE_PAYROLL: "PRP_UPDATE_PAYROLL",
  PRP_REQUEST_FAILED: "PRP_REQUEST_FAILED",
};

export default actionTypes;
